<glxy-page [pagePadding]="false" [mobileMaxWidth]="0">
  <glxy-page-toolbar>
    <glxy-page-title>
      <span>{{ 'INBOX.HEADER.TITLE' | translate }}</span>
    </glxy-page-title>
    <glxy-page-actions class="inbox-actions">
      @if (showNewMessageButton) {
        @if (featureFlagShowNewMessagePageInPC() && isPartnerCenter) {
          <a
            mat-flat-button
            color="primary"
            [routerLink]="['new-message']"
            [queryParamsHandling]="'merge'"
            data-action="clicked-new-message_top-bar"
            class="new-message-button"
          >
            <mat-icon aria-hidden="false" aria-label="Send a new message">edit_square</mat-icon>
            @if (isModal$ | async) {
              <span class="label">{{ 'INBOX.NEW_MESSAGE.NEW_MESSAGE' | translate }}</span>
            }
          </a>
        } @else {
          <ng-container>
            <button mat-flat-button color="primary" class="new-message" (click)="newMessage()">
              <mat-icon>add</mat-icon>
              @if (isModal$ | async) {
                <ng-container>
                  {{ 'INBOX.NEW_MESSAGE.NEW_MESSAGE' | translate }}
                </ng-container>
              }
            </button>
          </ng-container>
        }
      }
      <button
        #settingsButton
        *ngIf="showSettings$ | async"
        mat-icon-button
        class="menu-icon"
        (click)="navigateToSetting()"
      >
        <mat-icon>settings</mat-icon>
      </button>
      <button
        *ngIf="viewMode$ | async as state"
        mat-icon-button
        class="menu-icon fullscreen hide-on-mobile"
        (click)="toggleView(state)"
      >
        <mat-icon>{{ (isModal$ | async) ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
      </button>
      <button mat-icon-button class="menu-icon close" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <div class="inbox-container">
    <div
      class="inbox-panes"
      [class.has-conversations]="organizationHasConversations$ | async"
      [class.viewing-conversation]="(viewingConversation$ | async) || isViewingInPane()"
    >
      <div class="inbox-left-pane" *ngIf="organizationHasConversations$ | async">
        <inbox-pane
          [learnMoreUrl]="learnMoreUrl"
          [showSearchBar]="true"
          [emptySubtitleMessage]="'INBOX.EMPTY.MESSAGE_SUBTITLE'"
          conversationPath="conversations"
        ></inbox-pane>
      </div>

      <router-outlet></router-outlet>
    </div>
  </div>
</glxy-page>
